import { zonedTimeToUtc } from 'date-fns-tz';

export const convertDateToUTC = (date: Date, timezoneCode: string): string => {
  const utcDate = zonedTimeToUtc(date, timezoneCode);
  return utcDate.toISOString().slice(0, 16);
};
